module.exports = __webpack_public_path__ + "static/media/Moldflow Adviser Ultimate.320cd141.png";